import PlayGame from '../scenes/PlayGame';

export default class GameButton extends Phaser.GameObjects.Container {
  constructor({scene = null,
      x = 0,
      y = 0,
      w,
      h,
      text = "",
      radius,
      clickFunction,
      clickFunctionData,
      disabled = false,
      disabledAlpha = .4,
      enabledAlpha = 1,
      xText = w / 2,
      yText = h / 2,
      textShadow = null, // '#000000' for black
      visible = true,
      font = "32px Arial",
      fontColor = null,
      addToScene = true,
      selected = false,
      alpha = 1,
      depth = 1000,
      parentContainer = null,
      borderWidth = 3,
      bgAlpha = 1,
      labelText = null,
      keyBadge = null,
      selectedBorderColor = null,
      selectedBorderWidth = 5,
      bgColor = null,
      borderColor = null,
    }) {
    super(scene);
    this.scene = scene;
    this.clickFunction = clickFunction;
    this.clickFunctionData = clickFunctionData;
    this.disabled = disabled;
    this.selected = selected;
    this.disabledAlpha = disabledAlpha;
    this.x = x;
    this.y = y;
    this.btnWidth = w;
    this.btnHeight = h;
    this.btnRadius = radius;
    this.w = w;
    this.h = h;
    this.alpha = alpha;
    this.radius = radius;
    this.depth = depth;
    this.borderWidth = borderWidth;
    this.selectedBorderWidth = selectedBorderWidth;
    this.bgAlpha = bgAlpha;
    this.bgColor = bgColor;
    this.borderColor = borderColor;
    this.fontColor = fontColor;
    this.selectedBorderColor = selectedBorderColor;
    this.keyBadge = keyBadge;
    if (w !== undefined && h !== undefined) {
      this.setSize(w, h);
    }

    this.bgGraphics = new Phaser.GameObjects.Graphics(scene);
    this.selectedGraphics = new Phaser.GameObjects.Graphics(scene);
    this.selectedGraphics.setName("selectedStyle");
    this.selectedGraphics.setVisible(false);

    this.text = new Phaser.GameObjects.Text(scene, xText, yText, text, {
      font: font,
      color: '#ffffff',
      boundsAlignH: "center",
      boundsAlignV: "middle",
      align: 'center'
    });
    if (textShadow != null) {
      this.text.setShadow(3, 3, textShadow, 3, true);
    }
    this.text.setOrigin(0.5);

    if (labelText) {
      this.textLabelText = new Phaser.GameObjects.Text(scene, 6, 4, labelText, {
        font: '16px Arial',
        color: '#ffffff',
        boundsAlignH: "center",
        boundsAlignV: "middle",
        align: 'center'
      });
      this.textLabelText.setOrigin(0, 0);
      this.textLabelText.setDepth(depth - 1);
    }

    if (keyBadge) {
      this.keyBadgeContainer = new Phaser.GameObjects.Container(scene, 0, 0);
      this.keyBadgeGraphics = new Phaser.GameObjects.Graphics(scene);
      this.keyBadgeText = new Phaser.GameObjects.Text(scene, 0, 0, keyBadge, {
        font: keyBadge.length > 2 ? '11px Arial Bold' : '13px Arial Black',
        color: '#ffffff',
        align: 'center'
      }).setOrigin(0.5);
      this.keyBadgeContainer.add(this.keyBadgeGraphics);
      this.keyBadgeContainer.add(this.keyBadgeText);
      this.updateKeyBadgeLayout();
    }

    this.redraw();

    this.bgGraphics.setInteractive(new Phaser.Geom.Rectangle(0, 0, w, h), Phaser.Geom.Rectangle.Contains)
      .on('pointerdown', async () => { await this.click(); });

    this.setVisible(visible);
    this.add(this.bgGraphics);
    this.add(this.text);
    this.add(this.selectedGraphics);
    if (this.textLabelText) {
      this.add(this.textLabelText);
    }
    if (this.keyBadgeContainer) {
      this.add(this.keyBadgeContainer);
    }
    selected && this.select();

    if (addToScene && parentContainer == null) {
      scene.add.existing(this);
    }
    if (parentContainer) {
      parentContainer.add(this);
    }
  }

  updateKeyBadgeLayout() {
    if (!this.keyBadgeContainer || !this.keyBadge) return;
    const w = (this.btnWidth !== undefined && this.btnWidth !== 0) ? this.btnWidth : ((this.w !== undefined && this.w !== 0) ? this.w : (this.width || 200));
    const badgeW = this.keyBadge.length > 2 ? 38 : (this.keyBadge.length > 1 ? 28 : 22);
    const badgeH = 18;
    const badgeX = w - badgeW - 5;
    const badgeY = 5;

    this.keyBadgeGraphics.clear();
    this.keyBadgeGraphics.fillStyle(0x000000, 0.65);
    this.keyBadgeGraphics.fillRoundedRect(badgeX, badgeY, badgeW, badgeH, 4);
    this.keyBadgeGraphics.lineStyle(1.5, 0xffffff, 0.75);
    this.keyBadgeGraphics.strokeRoundedRect(badgeX, badgeY, badgeW, badgeH, 4);

    this.keyBadgeText.setPosition(badgeX + badgeW / 2, badgeY + badgeH / 2);
  }

  setKeyBadge(badge) {
    this.keyBadge = badge;
    if (!badge) {
      if (this.keyBadgeContainer) this.keyBadgeContainer.setVisible(false);
      return;
    }
    if (!this.keyBadgeContainer && this.scene) {
      this.keyBadgeContainer = new Phaser.GameObjects.Container(this.scene, 0, 0);
      this.keyBadgeGraphics = new Phaser.GameObjects.Graphics(this.scene);
      this.keyBadgeText = new Phaser.GameObjects.Text(this.scene, 0, 0, badge, {
        font: badge.length > 2 ? '11px Arial Bold' : '13px Arial Black',
        color: '#ffffff',
        align: 'center'
      }).setOrigin(0.5);
      this.keyBadgeContainer.add(this.keyBadgeGraphics);
      this.keyBadgeContainer.add(this.keyBadgeText);
      this.add(this.keyBadgeContainer);
    }
    if (this.keyBadgeContainer) {
      this.keyBadgeContainer.setVisible(true);
      this.keyBadgeText.setText(badge);
      this.keyBadgeText.setFont(badge.length > 2 ? '11px Arial Bold' : '13px Arial Black');
      this.updateKeyBadgeLayout();
    }
  }

  setPosition(x, y, z, w) {
    if (x === undefined) { x = 0; }
    if (y === undefined) { y = x; }
    this.x = x;
    this.y = y;
    if (z !== undefined) { this.z = z; }
    // Crucial: Phaser's Transform.setPosition(x, y, z, w) has w defaulting to 0.
    // In 2D games, we must never let setPosition(x, y) overwrite button width!
    return this;
  }

  redraw() {
    if (this.scene && this.scene.sys && this.scene.sys.settings && this.scene.sys.settings.status >= 8) {
      return;
    }
    const activeTheme = PlayGame.getActiveTheme ? PlayGame.getActiveTheme(this.scene) : null;
    const defaultBg = activeTheme ? activeTheme.button_bg_color : 0x540016;
    const defaultBorder = activeTheme ? activeTheme.button_border_color : 0xffca3a;
    const defaultText = activeTheme ? activeTheme.button_text_color : '#ffca3a';
    const defaultSelBorder = activeTheme ? (activeTheme.accent_color || activeTheme.button_border_color) : 0xffca3a;

    const fillCol = PlayGame.toColorInt ? PlayGame.toColorInt(this.bgColor != null ? this.bgColor : defaultBg) : (this.bgColor != null ? this.bgColor : defaultBg);
    const borderCol = PlayGame.toColorInt ? PlayGame.toColorInt(this.borderColor != null ? this.borderColor : (this.selectedBorderColor != null ? this.selectedBorderColor : defaultBorder)) : defaultBorder;
    const selBorderCol = PlayGame.toColorInt ? PlayGame.toColorInt(this.selectedBorderColor != null ? this.selectedBorderColor : defaultSelBorder) : defaultSelBorder;
    const txtCol = PlayGame.toColorStr ? PlayGame.toColorStr(this.fontColor != null ? this.fontColor : defaultText) : defaultText;

    const w = (this.btnWidth !== undefined && this.btnWidth !== 0) ? this.btnWidth : ((this.w !== undefined && this.w !== 0) ? this.w : (this.width || 200));
    const h = (this.btnHeight !== undefined && this.btnHeight !== 0) ? this.btnHeight : ((this.h !== undefined && this.h !== 0) ? this.h : (this.height || 50));
    const radius = this.btnRadius !== undefined ? this.btnRadius : (this.radius !== undefined ? this.radius : 15);

    if (this.bgGraphics) {
      this.bgGraphics.clear();
      this.bgGraphics.fillStyle(fillCol, 1);
      this.bgGraphics.fillRoundedRect(0, 0, w, h, radius);
      this.bgGraphics.lineStyle(this.borderWidth, borderCol, 1);
      this.bgGraphics.strokeRoundedRect(0, 0, w, h, radius);
      this.bgGraphics.setAlpha(this.bgAlpha);
    }
    if (this.selectedGraphics) {
      this.selectedGraphics.clear();
      this.selectedGraphics.lineStyle(this.selectedBorderWidth, selBorderCol, 1);
      this.selectedGraphics.strokeRoundedRect(0, 0, w, h, radius);
    }
    if (this.text) {
      try {
        this.text.setColor(txtCol);
      } catch (e) {
        // Ignored if frame disposed during scene transition
      }
    }
    if (this.textLabelText) {
      try {
        this.textLabelText.setColor(txtCol);
      } catch (e) {
        // Ignored if frame disposed during scene transition
      }
    }
    if (this.keyBadgeContainer) {
      this.updateKeyBadgeLayout();
    }
  }

  setStyle({ bgColor, borderColor, fontColor, selectedBorderColor, w, h, radius } = {}) {
    if (bgColor !== undefined) this.bgColor = bgColor;
    if (borderColor !== undefined) this.borderColor = borderColor;
    if (fontColor !== undefined) this.fontColor = fontColor;
    if (selectedBorderColor !== undefined) this.selectedBorderColor = selectedBorderColor;
    if (w !== undefined) { this.btnWidth = w; this.w = w; this.width = w; }
    if (h !== undefined) { this.btnHeight = h; this.h = h; this.height = h; }
    if (radius !== undefined) { this.btnRadius = radius; this.radius = radius; }
    this.redraw();
  }

  select() {
    this.selected = true;
    const s = this.getByName("selectedStyle");
    if (s) s.setVisible(true);
  }

  unselect() {
    this.selected = false;
    const s = this.getByName("selectedStyle");
    if (s) s.setVisible(false);
  }

  disable(disable) {
    this.disabled = disable;
    if (disable) {
      this.setAlpha(this.disabledAlpha);
    }
    else {
      this.setAlpha(this.enabledAlpha);
    }
  }

  async click(args) {
    if (this.disabled || this._isClicking) return;
    this._isClicking = true;
    this.unselect();
    let self = this;
    this.scene.tweens.addCounter({
      from: 100,
      to: 75,
      duration: 200,
      yoyo: true,
      onUpdate: tween => {
        if (!self.disabled) {
          let t = Math.floor(tween.getValue());
          self.setAlpha(t/100);
        }
      }
    }).play();
    try {
      await this.clickFunction.call(this.scene, args, this.clickFunctionData);
    } finally {
      setTimeout(() => {
        self._isClicking = false;
      }, 350);
    }
  }

}